/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--sidebar-width:200px;--viewport:100vw;--gutter-width:15px}.forgot-password[_ngcontent-%COMP%], .login[_ngcontent-%COMP%], .reset-password[_ngcontent-%COMP%]{min-height:100vh;background:#f3f6f9}.login-header[_ngcontent-%COMP%]{margin:1rem 0 3rem}"];
export { styles as styles };
